var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKioskSolid = function SvgKioskSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 9.016c0-.22.055-.41.164-.575l2.05-3.09c.247-.355.657-.601 1.095-.601h10.855c.438 0 .848.246 1.094.602l2.05 3.09c.11.163.192.355.192.574 0 .546-.465.984-1.012.984H4.234a.98.98 0 0 1-.984-.984ZM5 10.875h1.75v4.375H12v-4.375h1.75v6.563c0 .738-.602 1.312-1.313 1.312H6.314A1.296 1.296 0 0 1 5 17.437v-6.562Zm12.25 0H19v7c0 .492-.41.875-.875.875a.864.864 0 0 1-.875-.875v-7Z"
  })));
};

export default SvgKioskSolid;